module.exports = __webpack_public_path__ + "img/para_de_minas.b2dbe06b.png";